import { ReactNode } from "react";
import { CityLocationProvider } from "./CityLocationContext";
import { UserProvider } from "./UserContext";

export function AllContexts({ children }: { children: ReactNode }) {
  return (
    <CityLocationProvider>
      <UserProvider>
        {children}
      </UserProvider>
    </CityLocationProvider>
  );
} 